import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueNoty from './plugins/noty'
import VModal from 'vue-js-modal'
import VueCurrencyInput from 'vue-currency-input'
import axios from 'axios'
import {incomePlanAxios} from './axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { ValidationProvider} from 'vee-validate';
library.add(faFilePdf);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ValidationProvider', ValidationProvider);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.showLoader = true;
axios.defaults.showNotifications = true;

incomePlanAxios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
incomePlanAxios.defaults.withCredentials = true;

import './assets/css/questionnaire.scss';
import './assets/css/generic.scss';
import './assets/css/overwrite.css';

Vue.config.productionTip = false;
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.prototype.$api_url= process.env.VUE_APP_BASE_URL;

Vue.use(VueNoty);

const pluginOptions = {
    /* see config reference */
    globalOptions: { currency: 'USD', locale: 'en'}
}
Vue.use(VueCurrencyInput, pluginOptions)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'EinsteinFI'
  next()
});

import './filters';
import Echo from "laravel-echo";

window.io = require('socket.io-client');

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: process.env.VUE_APP_ECHO_URL
});

new Vue({
  router,
  store,
  vuetify,
  created() {
      //@todo to refactor
      incomePlanAxios.interceptors.response.use(
          response => {
              if (response.data && response.data.message && response.config.showNotifications) {
                  this.$noty.success(response.data.message);
              }

              return response;
          },
          error => {
              let response = error.response;

              // Skip login/logout URLs
              if (response && response.status === 401 && (
                  response.config.url !== '/client/login' &&
                  response.config.url !== '/client/logout' &&
                  response.config.url !== '/client/password/email'
              )) {
                  // Logout the user if response is 401
                  if (!this.$store.state.auth.loggingOut) {
                      this.$store.commit('auth/setLoggingOut', true);
                      this.$router.push({path: `/login/${this.$store.state.settings.companyKey}`, query: {cud: '1'}})
                  }
              }

              let message = 'Request failed';
              if (response.data && response.data.message) {
                  message = response.data.message;
              }

              //Log troubleshooting data
              if (response.config.showNotification) {
                  this.$noty.error(message);
                  console.log(message);
              }

              //Reject with user friendly errors
              return Promise.reject(error.response.data.errors);
          }
      );

    axios.interceptors.request.use(
        config => {
            if (config.showLoader) {
                // store.dispatch('loader/pending');
            }
            return config;
        },
        error => {
            if (error.config.showLoader) {
                // store.dispatch('loader/done');
            }
            return Promise.reject(error);
        }
    );
    axios.interceptors.response.use(
        response => {
            // Display Noty success message
            // let status = 'success';
            if (response.data) {
                if (response.data.status) {
                    // status = response.data.status;
                }

                if (response.data.message && response.config.showNotifications) {
                    // this.$noty[status](response.data.message);
                }
            }

            if (response.config.showLoader) {
               //store.dispatch('loader/done');
            }

            return response;
        },
        error => {
            let response = error.response;

            // Skip login/logout URLs
            if (response && response.status === 401 && (
                    response.config.url !== '/client/login' &&
                    response.config.url !== '/client/logout' &&
                    response.config.url !== '/client/password/email'
            )) {
                if (!this.$store.state.auth.loggingOut && this.$store.state.auth.user) {
                    this.$store.commit('auth/setLoggingOut', true);
                    this.$router.push({path: `/login/${this.$store.state.settings.companyKey}`, query: {cud: '1'}})
                }
            }

            // let message = 'Request failed';
            if (response.data && response.data.message) {
                // message = response.data.message;
            }

            if (response.config.showNotifications) {
                // this.$noty.error(message);
            }

            if (response.config.showLoader) {
                // store.dispatch('loader/done');
            }

            return Promise.reject(error);
        }
    )
  },
  render: h => h(App)
}).$mount('#app')
